export default[
    {
        name: 'SearchWrite',
        path: 'SearchWrite',
        component: () => import('@/pages/Patent/SearchWrite'),
        meta: { title: '检索与撰写' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
        
            }
        }
    },
    {
        name: 'InvalidationResponse',
        path: 'InvalidationResponse',
        component: () => import('@/pages/Patent/InvalidationResponse'),
        meta: { title: '无效与答辩' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
        
            }
        }
    },
    {
        name: 'TransferLicense',
        path: 'TransferLicense',
        component: () => import('@/pages/Patent/TransferLicense'),
        meta: { title: '转让与许可' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
        
            }
        }
    },
    {
        name: 'FastExamination',
        path: 'FastExamination',
        component: () => import('@/pages/Patent/FastExamination'),
        meta: { title: '优审与快审' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
        
            }
        }
    },
    {
        name: 'Planning',
        path: 'Planning',
        component: () => import('@/pages/Patent/Planning'),
        meta: { title: '布局与规划' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    }
]